var apiUrl = '/api';

const b2bSwitch = $('.page-top-bar__company-switch-b2b-option');
const b2cSwitch = $('.page-top-bar__company-switch-private-option');
const yourPriceButton = $('.price-switch__your');
const endCustomerPriceButton = $('.price-switch__end-customer');

if (b2bSwitch.length > 0) {
    b2bSwitch.on('click', () => {
        b2cSwitch.removeClass('--active');
        b2bSwitch.addClass('--active');
        setCookie('b2b-homepage', '1', 365);
        window.location.reload();
    })
}

if (b2cSwitch.length > 0) {
    b2cSwitch.on('click', () => {
        b2bSwitch.removeClass('--active');
        b2cSwitch.addClass('--active');
        setCookie('b2b-homepage', '0', 365);
        window.location.reload();
    })
}

yourPriceButton.on('click', () => {
    showYourPrice(true);
});

endCustomerPriceButton.on('click', () => {
    showCustomerPrice(true);
});

checkIfBrowserIsInternetExplorer();
checkIfLinkHasCompanyHashtag();
showInitialB2bPopup();
addOpenAndCloseActionsToModals();
setPriceSwitchState();

function showYourPrice(setClientCookie) {
    endCustomerPriceButton.removeClass('--active');
    yourPriceButton.addClass('--active');

    $(document).find('.end-customer-price').removeClass('active');
    $(document).find('.your-price').addClass('active');

    if (setClientCookie) {
        setCookie('display-end-customer-price', '0', 365);
    }
}

function showCustomerPrice(setClientCookie) {
    yourPriceButton.removeClass('--active');
    endCustomerPriceButton.addClass('--active');

    $(document).find('.end-customer-price').addClass('active');
    $(document).find('.your-price').removeClass('active');

    if (setClientCookie) {
        setCookie('display-end-customer-price', '1', 365);
    }
}

function setPriceSwitchState() {
    const displayEndCustomerPriceState = getCookie('display-end-customer-price');

    if (displayEndCustomerPriceState === '1') {
        showCustomerPrice(false);
    } else {
        showYourPrice(false);
    }
}

function checkIfBrowserIsInternetExplorer() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident/)) // If Internet Explorer, return version number
    {
        $('#IEinfo').show();
    }

    return false;
}

function getWidth() {
    if (self.innerWidth) {
        return self.innerWidth;
    }
    if (document.documentElement && document.documentElement.clientWidth) {
        return document.documentElement.clientWidth;
    }
    if (document.body) {
        return document.body.clientWidth;
    }
}

function countClickOnElement(categoryId, elementId) {
    $.ajax({
        type: "POST",
        url: apiUrl + '/count-element-click',
        data: {
            categoryId: categoryId,
            elementId: elementId
        },
        cache: false
    });
}

$('.active .clickable').on('click', function(e) {
    if ($(this).hasClass('panel-collapsed')) {
        // expand the panel
        $(this).parent('.active').find('.collapsein').first().slideDown();
        $(this).removeClass('panel-collapsed');
        $(this).find('i, em').removeClass('fa-plus').addClass('fa-minus');
    } else {
        // collapse the panel
        $(this).parent('.active').find('.collapsein').first().slideUp();
        $(this).addClass('panel-collapsed');
        $(this).find('i, em').removeClass('fa-minus').addClass('fa-plus');
    }
});

function loadMainMenuImages(imageGroups) {
    imageGroups.forEach(function(images) {
        $.each(images, function(index, image) {
            image.setAttribute('src', image.dataset.src);
        });
    });
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    var secure = '';

    if (isSecureOnly === 1) {
        secure = ';Secure';
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ';path=/;SameSite=Lax' + secure;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var observer = lozad(); // lazy loads elements with default selector as '.lozad'

$(document).ready(function() {
    observer.observe();

    // lazyload images in loaded subpages
    var pageImages = document.querySelectorAll('#additional-page-content img');
    if (pageImages.length > 0) {
        lozad(pageImages).observe()
    }

    const loginButton = document.querySelector('.page-top-bar__my-account');
    const loginModal = document.querySelector('.page-my-account-modal');
    const loginModalClose = document.querySelector('.page-my-account-modal__header-close-button');
    const greyBackground = document.querySelector('.page-top-bar__grey-background');
    loginButton.addEventListener('click', function(e) {
        e.stopPropagation();
        loginModal.classList.toggle('--active');
        greyBackground.classList.toggle('--active');
    });
    loginModalClose.addEventListener('click', function(e) {
        e.stopPropagation();
        loginModal.classList.toggle('--active');
        greyBackground.classList.toggle('--active');
    });

    $('.page-top-bar__grey-background').on('click', function(e) {
        e.stopPropagation();
        $('.page-top-bar__showrooms-modal').removeClass('--active');
        $('.page-customer-service-modal').removeClass('--active');
        $('.page-checkout-modal').removeClass('--active');
        $('.page-my-account-modal').removeClass('--active');
        $('.search-input-modal').removeClass('--active');
        $('.page-top-bar__grey-background').removeClass('--active');
        $('.page-top-bar__chat-modal').removeClass('--active');
        $('.page-top-bar__tasks-modal').removeClass('--active');
        $('.page-main-menu__greyBackground').removeClass('--searchVisible');

    })
    $('.page-main-menu__greyBackground').on('click', function(e) {
        e.stopPropagation();
        $('.page-top-bar__showrooms-modal').removeClass('--active');
        $('.page-customer-service-modal').removeClass('--active');
        $('.page-checkout-modal').removeClass('--active');
        $('.page-my-account-modal').removeClass('--active');
        $('.search-input-modal').removeClass('--active');
        $('.page-main-menu__greyBackground').removeClass('--searchVisible');
        $('.page-top-bar__chat-modal').removeClass('--active');
        $('.page-top-bar__tasks-modal').removeClass('--active');
        $('.page-top-bar__grey-background').removeClass('--active');
    })

    const checkoutModal = document.querySelector('.page-checkout-modal');
    $('.page-main-header__actions-icon-wrapper.--checkout').on('click', function(e) {
        e.stopPropagation();
        checkoutModal.classList.toggle('--active');
        greyBackground.classList.toggle('--active');
    })

    $('.page-checkout-modal__header-close-button').on('click', function(e) {
        e.stopPropagation();
        checkoutModal.classList.toggle('--active');
        greyBackground.classList.toggle('--active');
    })

    $('.page-main-menu__item-showroom-button').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('.page-top-bar__showrooms-modal').addClass('--active');
    });
    $('.page-top-bar__showrooms-modal-header-close-button').on('click', function(e) {
        e.stopPropagation();
        $('.page-top-bar__showrooms-modal').toggleClass('--active');
    });

    $('.page-top-bar__chat-wrapper').on('click', function(event) {
        event.stopPropagation();
        $('.page-main-menu__greyBackground').addClass('--searchVisible');
        $(this).find('.page-top-bar__chat-modal').addClass('--active');
    });
    $('.page-top-bar__chat-modal-header-close-button').on('click', function(e) {
        e.stopPropagation();
        $(this).parents('.page-top-bar__chat-modal').toggleClass('--active');
        $('.page-main-menu__greyBackground').toggleClass('--searchVisible');
    });

    $('.page-top-bar__tasks-wrapper').on('click', function(event) {
        event.stopPropagation();
        $('.page-main-menu__greyBackground').addClass('--searchVisible');
        $(this).find('.page-top-bar__tasks-modal').addClass('--active');
    });
    $('.page-top-bar__tasks-modal-header-close-button').on('click', function(e) {
        e.stopPropagation();
        $(this).parents('.page-top-bar__tasks-modal').toggleClass('--active');
        $('.page-main-menu__greyBackground').toggleClass('--searchVisible');
    });

    $('.page-customer-service-modal__header-close-button').on('click', function(e) {
        e.stopPropagation();
        $('.page-customer-service-modal').toggleClass('--active');
        $('.page-main-menu__greyBackground').toggleClass('--searchVisible');
    });

    $('.page-main-header__actions-icon-wrapper.--contact').on('click', function(event) {
        event.stopPropagation();
        $('.page-main-menu__greyBackground').addClass('--searchVisible');
        $('.page-customer-service-modal').toggleClass('--active');
    });

    $('.page-main-header__actions-icon-wrapper.--search').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('.search-input-modal__content-search-words').empty();
        defaultSearchWords.forEach(function(defaultWord) {
            $('.search-input-modal__content-search-words').append('<span class="search-input-modal__search-word">' + defaultWord + '</span>');
        });
        $('.page-main-menu__greyBackground').addClass('--searchVisible');
        $('.search-input-modal').toggleClass('--active');
    });

    $('.search-input__form-input').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('.search-input-modal__content-search-words').empty();
        defaultSearchWords.forEach(function(defaultWord) {
            $('.search-input-modal__content-search-words').append('<span class="search-input-modal__search-word">' + defaultWord + '</span>');
        });
        $('.page-main-menu__greyBackground').addClass('--searchVisible');
        $('.search-input').addClass('--zindexHigh');
        $('.search-input-modal').addClass('--active');
    });

    $('.search-input__form-input').on('keyup', function() {
        event.preventDefault();
        event.stopPropagation();
        var inputVal = $(this).val().toLowerCase();
        if (inputVal === '') {
            $('.search-input-modal__content-search-words').empty();
            defaultSearchWords.forEach(function(defaultWord) {
                $('.search-input-modal__content-search-words').append('<span class="search-input-modal__search-word">' + defaultWord + '</span>');
            });
        } else {
            $('.search-input-modal__content-search-words').empty();
            var results = allSearchWords.filter(function(word) {
                return (word.indexOf(inputVal) > -1);
            })
            results.forEach(function(word) {
                $('.search-input-modal__content-search-words').append('<span class="search-input-modal__search-word">' + word + '</span>');
            });
        }
    });

    $('.search-input-modal').on('click', function(e) {
        event.preventDefault();
        if (e.target.classList.contains('search-input-modal__search-word')) {
            $('.search-input__form-input').val(e.target.textContent);
            $('.search-input__form').submit();
        }
    });
    $(".search-input-modal__header-close-button").on('click', function(e) {
        e.stopPropagation();
        $('.search-input-modal').toggleClass('--active');
        $('.search-input').toggleClass('--zindexHigh');
        $('.page-main-menu__greyBackground').toggleClass('--searchVisible');
    })

    // MAIN MENU
    if (getWidth() > 1023) {
        if (isMobile) {
            $('.page-main-menu__items a').on('click', function(e) {
                if ($(this).hasClass('page-main-menu__itemTitle') && !$(this).hasClass('--singleLink')) {
                    e.preventDefault();
                    var submenu = $(this).siblings('.subMenu');
                    var submenuSimple = $(this).siblings('.subMenuSimple');
                    if (submenu.length > 0 || submenuSimple.length > 0) {
                        $('.page-main-menu__item').removeClass('--active');
                        $(this).addClass('--active');
                        $('.page-main-menu__greyBackground').addClass('display-block');
                        $('.subMenu').removeClass('--active');
                        $('.subMenuSimple').removeClass('--active');
                        $(this).siblings('div').addClass('--active');
                    } else {
                        $(this).removeClass('--active');
                        $('.page-main-menu__greyBackground').removeClass('display-block');
                        $(this).children('div').removeClass('--active');
                    }
                    var materialsImages = submenu.find('.subMenu__materials img');
                    var materialProductsImages = submenu.find('.subMenu__materialsProducts.--active').find('img');

                    loadMainMenuImages([materialsImages, materialProductsImages]);
                }

                if ($(this).hasClass('subMenu__materialsItem')) {
                    e.preventDefault();
                }
            });

            $('.page-main-menu__greyBackground').on('click', function(e) {
                $('.subMenu.--active').removeClass('--active');
                $('.page-main-menu__itemTitle.--active').removeClass('--active');
                $('.page-main-menu__greyBackground').removeClass('display-block');
            });

        } else {
            $('.page-main-menu__item').on('mouseenter', function() {
                var submenu = $(this).find('.subMenu');
                var submenuSimple = $(this).find('.subMenuSimple');
                if (submenu.length > 0 || submenuSimple.length > 0) {
                    $('.page-main-menu__greyBackground').addClass('display-block');
                    var materialsImages = $(this).find('.subMenu .subMenu__materials img');
                    var materialProductsImages = submenu.find('.subMenu__materialsProducts.--active').find('img');
                    loadMainMenuImages([materialsImages, materialProductsImages]);
                }
            }).on('mouseleave', function() {
                $('.page-main-menu__greyBackground').removeClass('display-block');
            })

        }

        $('.subMenu__materialsPosition')
            .on('mouseenter click', function() {
                var id = $(this).data('id');

                $('.subMenu__materialsPosition').removeClass('--active');
                $(this).addClass('--active');
                var products = $('.subMenu__materialsProducts[data-id="' + id + '"]');
                if (products.length > 0) {
                    $('.subMenu__materialsProducts').removeClass('--active');
                    products.addClass('--active');
                    loadMainMenuImages([products.find('img')]);
                }
            });

        $('.subMenu')
            .on('mouseleave', function() {
                $('.subMenu__materialsPosition').removeClass('--active');
                $('.subMenu__materialsProducts').removeClass('--active');
                $('.subMenu__materials').each(function(index, elem) {
                    elem.children[0].classList.add('--active');
                });
            });
    } else {
        $(".page-main-header__actions-icon-wrapper.--menu").on('click', function() {
            $('.page-main-menu__wrapper').toggleClass('--active');
        })
        $(".page-main-menu__header-close-button").on('click', function() {
            $('.page-main-menu__wrapper').toggleClass('--active');
        })
        $(".page-main-menu__itemDropdown").on('click', function(e) {
            $('.subMenu .--active').removeClass('--active');
            $('.subMenu__materialsPosition .fa-minus').removeClass('fa-minus').addClass('fa-plus');
            var submenu = $(this).siblings('.subMenu');
            var subMenuSimple = $(this).siblings('.subMenuSimple');

            var position = 0;
            if (submenu.length > 0) {
                e.preventDefault();
                if (submenu.hasClass('--mobileVisible')) {
                    submenu.removeClass('--mobileVisible');
                    $(this).removeClass('fa-minus').addClass('fa-plus');

                } else {
                    $('.subMenu').removeClass('--mobileVisible');
                    $('.subMenuSimple').removeClass('--mobileVisible');
                    submenu.addClass('--mobileVisible');
                    $('.page-main-menu__itemDropdown').removeClass('fa-minus').addClass('fa-plus');
                    $(this).removeClass('fa-plus').addClass('fa-minus');

                    var materialsImages = $(this).parent().find('.subMenu .subMenu__materials img');
                    var materialProductsImages = submenu.find('.subMenu__materialsProducts.--active').find('img');
                    loadMainMenuImages([materialsImages, materialProductsImages]);

                    $('.page-main-menu__container.--active').scrollTop(0);
                    if ($('.subMenu.--mobileVisible').length > 0) {
                        position = $('.subMenu.--mobileVisible').position().top - 40;
                    }
                    $('.page-main-menu__container.--active').scrollTop(position);

                }
            }

            if (subMenuSimple.length > 0) {
                e.preventDefault();
                if (subMenuSimple.hasClass('--mobileVisible')) {
                    subMenuSimple.removeClass('--mobileVisible');
                    $(this).removeClass('fa-minus').addClass('fa-plus');
                } else {
                    $('.subMenuSimple').removeClass('--mobileVisible');
                    $('.subMenu').removeClass('--mobileVisible');
                    subMenuSimple.addClass('--mobileVisible');
                    $('.page-main-menu__itemDropdown').removeClass('fa-minus').addClass('fa-plus');
                    $(this).removeClass('fa-plus').addClass('fa-minus');
                }
                $('.page-main-menu__container.--active').scrollTop(0);
                position = $('.page-main-menu__item.--relativePosition').position().top;
                $('.page-main-menu__container.--active').scrollTop(position);
            }
        });

        // we want to close default materials types before menu opening
        $('.subMenu__materialsProducts').removeClass('--active');
        $(".subMenu__itemDropdown").on('click', function(e) {
            var id = $(this).data('id');
            var order = $(this).parent().data('order');
            var materialsPosition = $('.subMenu__materialsPosition[data-id="' + id + '"]');
            var products = $('.subMenu__materialsProducts[data-id="' + id + '"]');

            if (materialsPosition.hasClass('--active')) {
                materialsPosition.removeClass('--active');
                products.removeClass('--active');
                $('.subMenu__itemDropdown').removeClass('fa-minus').addClass('fa-plus');
            } else {
                $('.subMenu__materialsPosition').removeClass('--active');
                materialsPosition.addClass('--active');
                $('.subMenu__itemDropdown').removeClass('fa-minus').addClass('fa-plus');
                $(this).removeClass('fa-plus').addClass('fa-minus');

                if (products.length > 0) {
                    $('.subMenu__materialsProducts').removeClass('--active');
                    products.addClass('--active');
                    loadMainMenuImages([products.find('img')]);
                }
            }

            $('.page-main-menu__container.--active').scrollTop(0);
            if ($('.subMenu__materialsPosition.--active').length > 0) {
                position = $('.subMenu.--mobileVisible').position().top;
                position += $('.subMenu__materialsPosition.--active').position().top;
            }
            $('.page-main-menu__container.--active').scrollTop(position);
        });
    }

    $('.scroll-to-additional-page-content').on('click', function() {
        $('body,html').animate({
            scrollTop: $("#additional-page-content").offset().top
        }, 500);
    });

    $('.tab').on('click', function() {
        $('.tab').removeClass('active-tab');
        $(this).addClass('active-tab');
    })

    $(".read-more").attr("data-toggle", "modal")
        .attr("data-target", ".modal-product-info");

    $(".assign").attr("data-toggle", "modal")
        .attr("data-target", ".modal-assign");

    $(".option").on("click", function() {
        $(this).toggleClass('checked-item');
    })

    $('.show-notes').on("click", function() {
        $(this).siblings('.notes').toggleClass('display-block');
    })

    $('.custom-select').on('click', function() {
        $('.types-list').toggle();
    })

    $('.custom-modal-opener').on('click', function(event) {
        event.stopPropagation();
        $($(this).attr('data-target')).modal();
    });
    loadCart();

    $('.page-my-account-modal__content-menu-group > .page-my-account-modal__content-menu-group-name').on('click', function() {
        let groupContent = $(this).parent().find('.page-my-account-modal__content-menu-group-content');
        if (groupContent.css('display') === 'block') {
            groupContent.css('display', 'none');
        } else if (groupContent.css('display') === 'none') {
            groupContent.css('display', 'block');
        }
    });

    $('.element-counter').click(function() {
        countClickOnElement($(this).data('category-id'), $(this).data('element-id'));
    });

    $('body').on('scroll', function() {
        if ($(this).scrollTop() >= 350) {
            $('.scroll-to-top').addClass('--active');
        } else {
            $('.scroll-to-top').removeClass('--active');
        }
    });
    $('.scroll-to-top').on('click', function() { // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0 // Scroll to top of body
        }, 500);
    });
    $('[data-toggle="tooltip"]').tooltip();

    $(document).on('keydown', function(event) {
        // ctrl + shift + z
        if (
            event.ctrlKey &&
            event.shiftKey &&
            event.which === 90
        ) {
            const displayEndCustomerPriceState = getCookie('display-end-customer-price');

            if (displayEndCustomerPriceState === '1') {
                showYourPrice(true);
            } else {
                showCustomerPrice(true);
            }
        }
    });

    cartValidation();
});

function cartValidation() {
    if (typeof cart === 'undefined') {
        return false;
    }
    var cartValidationTask = setInterval(() => {
        $.ajax({
            cache: false,
            type: 'POST',
            url: apiUrl + '/validate-cart',
            data: {
                'cart': cart,
            },
        }).done(function(response) {
            if (!response.status) {
                clearInterval(cartValidationTask);
                window.location.href = response.redirect;
            }
        })
    }, 3000);
}

function getWatchVideoPinterestEvent(videoTitle) {
    pintrk('track', 'watchvideo', {
        video_title: videoTitle
    });
}

function formatPrice(x) {
    return Math.floor(x).toString().split('').reverse().reduce(function(acc, cur, index) {
        return acc.toString() + ((index % 3 === 0) ? ' ' : '') + cur;
    }).split('').reverse().join('') + "." + ("00" + Math.round(100 * (x % 1))).slice(-2);
}

function loadCart() {
    $.ajax({
        url: apiUrl + '/get-cart',
        cache: false
    }).done(function(response) {
        if (response.data && response.data[0]) {
            $('div.cart').addClass("animate-cart");
            updateCart(response.data);
        }
    })
}

function updateCart(data) {
    function fillData($product, id, values) {
        values['product-id'] = values['id'];
        values['total-price'] = values['price'] * values['quantity'];
        values['id'] = id;
        values['formatted-price'] = values['formatted']['price'];
        values['formatted-total-price'] = values['formatted']['totalPrice'];

        $product.find('[data-product]').each(function(i, elem) {
            var param = $(elem).data('product');
            switch ($(elem).data('type')) {
                case 'src':
                    $(elem).attr('src', values[param]);
                    break;
                case 'remove':
                    $(elem).attr('data-id', values['product-id']);
                    break;
                case 'quantity':
                    $(elem).attr('value', values['quantity']);
                    $(elem).attr('data-id', values['product-id']);
                    break;
                case 'currency':
                    $(elem).text(parseInt(values[param]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr');
                    break;
                default:
                    $(elem).html(values[param]);
            }
        });

        return $product;
    }
    var $list = $('.page-checkout-modal__positionList');
    var $productTemplate = $('.page-checkout-modal__position.--template');
    var i;
    data = Array.isArray(data) ? data : [data];

    $list.find('.page-checkout-modal__position').not('.--template').remove();
    $('.page-main-header__checkout-counter').text(data.length);

    for (i = 0; i < data[0].cartItems.length; i++) {
        var $product = $productTemplate.clone();
        $product.removeClass('--hidden');
        $product.removeClass('--template');
        $product = fillData($product, i + 1, data[0].cartItems[i]);
        $product.appendTo($list);
    }

    $('.page-checkout-modal__summary-price-value').text(data[0].cartDetails.formatted.totalPrice);

    quantityInputs = $('.page-checkout-modal__positionQuantity input');
    quantityInputs.on('change', function() {
        var mainUrl = apiUrl + '/change-position-quantity-in-cart';
        var data = {
            productId: $(this).data('id'),
            quantity: $(this).val(),
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        };
        $.ajax({
            url: mainUrl,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(data),
            success: function(response) {
                if (response.meta.success) {
                    var url = window.location.href;
                    if (url.indexOf('kassa') > -1) {
                        window.location.reload();
                    } else {
                        loadCart();
                    }
                }
            }
        })
    });

    cartDirectDeleteButtons = $('.page-checkout-modal__positionDelete');
    cartDirectDeleteButtons.on('click', function() {
        var mainUrl = apiUrl + '/direct-remove-product/' + $(this).attr('data-id');
        $.ajax({
            url: mainUrl,
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            success: function(response) {
                if (response.meta.success) {
                    if (response.data[0].emptyCart) {
                        clearCart();
                    } else {
                        var url = window.location.href;
                        if (url.indexOf('kassa') > -1) {
                            window.location.reload();
                        } else {
                            loadCart();
                        }
                    }
                }
            }
        })
    });

    if ($('.price-switch').length === 0) {
        setCookie('display-end-customer-price', '0', 365);
    }
}

function clearCart() {
    $('.page-checkout-modal__position:not(.--template)').remove();
    $('.page-checkout-modal__summary-price-value').text(0);
    $('.page-main-header__checkout-counter').text(0);
    var url = window.location.href;
    if (url.indexOf('kassa') > -1) {
        window.location.reload();
    }
}

$(function() {
    $("[data-datepicker]").each(function(i, e) {
        $(e).datepicker({
            dateFormat: $(e).attr('data-datepicker')
        });
    });
});

function recalculateDeliveryPrice(selectedShippingPrice) {
    var totalExShipping = $('#summary-price__totalExShipping');
    var shipping = $('#summary-price__shipping');
    var total = $('#summary-price__total');
    var netprice = $('#summary-price__netprice');
    var tax = $('#summary-price__alltaxes');

    totalExShippingValue = totalExShipping.data('value');
    totalValue = totalExShippingValue + selectedShippingPrice;
    netpriceValue = Math.round(totalValue / 1.25);
    taxValue = totalValue - netpriceValue;
    shipping.text(selectedShippingPrice);
    total.text(totalValue.toLocaleString('pl-PL'));
    netprice.text(netpriceValue.toLocaleString('pl-PL'));
    tax.text(taxValue.toLocaleString('pl-PL'));
}

// searching delivery price by postcode (API call)
function homedeliveryCheckPrice(postCode, responseFunction, isLong, shippingOptionId) {
    isLong = isLong ? isLong : false;
    $('#calculatedDeliveryPrice').text('Räkna ut pris...').removeClass('red');
    $.ajax({
        url: apiUrl + '/get-delivery-price',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
            postcode: postCode,
            isLongProduct: isLong,
            shippingOptionId: shippingOptionId,
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        }),
        success: responseFunction
    });
}

function addOpenAndCloseActionsToModals() {
    $('.notes-modal__wrapper').each(function() {
        const modal = $(this);
        const modalId = modal.data('modalId');

        $(`button[data-modal-id=${modalId}]`).click(function(event) {
            modal.removeClass('--hidden');
            event.preventDefault();
        });
    });

    $('.notes-modal__closeBtn').click(closeModals);

    function closeModals() {
        $('.notes-modal__wrapper').each(function() {
            $(this).addClass('--hidden');
        });
    }
};

function checkIfLinkHasCompanyHashtag() {
    let b2bSwitchStatus = getCookie('b2b-homepage');

    if (window.location.hash.includes('#company') && b2bSwitchStatus !== '1') {
        b2cSwitch.removeClass('--active');
        b2bSwitch.addClass('--active');
        setCookie('b2b-homepage', '1', 365);
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }
}

function showInitialB2bPopup() {
    let b2bSwitchStatus = getCookie('b2b-homepage');
    if (b2bSwitchStatus === '1') {
        b2cSwitch.removeClass('--active');
        b2bSwitch.addClass('--active');
    } else {
        b2bSwitch.removeClass('--active');
        b2cSwitch.addClass('--active');
    }

    if (b2bSwitchStatus === "" && !window.location.hash.includes('#company')) {
        $('.b2bPopup').addClass('--visible');

        $('.b2bPopup__company-client').click(function() {
            setCookie('b2b-homepage', '1', 365);
            window.location.reload();
        });

        $('.b2bPopup__private-client').click(function() {
            setCookie('b2b-homepage', '0', 365);
            window.location.reload();
        });
    }
};

function isB2bModeEnabled() {
    let b2bSwitchStatus = getCookie('b2b-homepage');
    return b2bSwitchStatus === '1';
}
